import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../Anchor';
import { setDetailPageUrl } from '../../../lib/common';
import { VERSION_EDIT_URL_PATH } from '../../../constants/service/common/urlConstants';

const OpenVersionDetail = (props) => {
  const { text, versionId } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) && isNil(versionId)) {
    return '-';
  }

  return (
    <Anchor
      text={text}
      isUnderLine
      color="primary"
      href={setDetailPageUrl(VERSION_EDIT_URL_PATH, versionId)}
      target="_blank"
    />
  );
};

export default OpenVersionDetail;
